import React from 'react';
import { useThemeStore } from '../../stores/useThemeStore';
import WatermarkManager from '../ui/WatermarkManager/WatermarkManager';
import SvgPositionedElement from '../ui/SvgPositionedElement/SvgPositionedElement';
import ScrapbookFooter from './ScrapbookFooter';
import './MainLayout.css';

interface MainLayoutProps {
    children: React.ReactNode;
    hideWatermarks?: boolean; // Hidden while the app is loading
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, hideWatermarks = false }) => {
    const { theme } = useThemeStore();

    return (
        <div
            className="main-layout"
            data-theme={theme}
        >
            <main className="main-content">
                {children}

                {!hideWatermarks && (
                    <WatermarkManager />
                )}
            </main>
            <div
                className="footer-spacer"
                aria-hidden="true"
                data-testid="footer-spacer"
            >
                {!hideWatermarks && (
                    <SvgPositionedElement
                        svgPath="/blackboard_selection.svg"
                        fixed={false}
                        className="footer-spacer-blackboard"
                        useThemeColors={true}
                        fadeTarget=".btn--theme-toggle"
                        data-testid="svg-blackboard-footer-spacer"
                    />
                )}
            </div>
            <ScrapbookFooter />
        </div>
    );
};

export default MainLayout;